import request from './request';

// 碰撞事故概况统计

export function getOverviewAmount(params) {
    return request('/stat/clue/overview/amount', {
        method: 'GET',
        params,
    });
}

export function getOverviewTime(params) {
    return request('/stat/clue/overview/time', {
        method: 'GET',
        params,
    });
}

export function getAssigneeList(params) {
    return request('/stat/clue/assignee/list', {
        method: 'POST',
        params,
    });
}
